<template lang="html">
  <div class="wrapper">
    <p v-if="timerSecs > 1">COMMS RECEIVED: <span v-if="timerSecs > 2">ALL_CLEAR !</span></p>
    <p v-if="timerSecs > 3.5">DANGER ASSESSMENT: <span v-if="timerSecs > 4.5">NOMINAL</span></p>
    <br>
    <p v-if="timerSecs > 6">TERMINATING __LOCKDOWN__ PROTOCOL
      <span v-if="timerSecs > 7">.</span>
      <span v-if="timerSecs > 7.25">.</span>
      <span v-if="timerSecs > 7.5">.</span>
    </p>
    <br>
    <p v-if="timerSecs > 9">INITIATING REBOOT CYCLE
      <span v-if="timerSecs > 10">.</span>
      <span v-if="timerSecs > 10.25">.</span>
      <span v-if="timerSecs > 10.5">.</span>
    </p>
    <br>
    <p v-if="timerSecs > 12">INIT [WEAPONS]
      <span v-if="timerSecs > 13">.</span>
      <span v-if="timerSecs > 13.25">.</span>
      <span v-if="timerSecs > 13.5">.</span>
    </p>
    <p v-if="timerSecs > 14">COMPLETE !</p>
    <p v-if="timerSecs > 15">[WEAPONS] ONLINE !</p>
    <br>
    <p v-if="timerSecs > 16.5">INIT [MOBILITY]
      <span v-if="timerSecs > 17.5">.</span>
      <span v-if="timerSecs > 17.75">.</span>
      <span v-if="timerSecs > 18">.</span>
    </p>
    <p v-if="timerSecs > 18.5">COMPLETE !</p>
    <p v-if="timerSecs > 19.5">[MOBILITY] ONLINE !</p>
    <br>
    <p v-if="timerSecs > 21">UNLOCKING [BLAST_DOOR]
      <span v-if="timerSecs > 21.5">.</span>
      <span v-if="timerSecs > 21.75">.</span>
      <span v-if="timerSecs > 22">.</span>
    </p>
    <p v-if="timerSecs > 22.5">COMPLETE !</p>
    <p v-if="timerSecs > 23.5">[EGRESS] ONLINE !</p>
    <br>
    <p v-if="timerSecs > 25">REBOOT CYCLE: <span v-if="timerSecs > 26">COMPLETE !</span></p>
    <p v-if="timerSecs > 27.5">__LOCKDOWN__ PROTOCOL: <span v-if="timerSecs > 28.5">TERMINATED !</span></p>
    <br>
    <transition name="fade">
      <button v-if="timerSecs > 30" @click="showThankyouHandler">Disembark</button>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Outro',
  data() {
    return {
      timer: 0,
      showThankyou: true,
    }
  },
  computed: {
    timerSecs() {
      return this.timer / 1000;
    },
  },
  methods: {
    count() {
      let delay = 250;
      if (this.timer < 40000 && this.$router.currentRoute.name === 'outro') {
        setTimeout(() => {
          this.timer += delay;
          this.count();
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: 'smooth',
          });
        }, delay);
      }
    },
    showThankyouHandler() {
      this.$emit('showThankyou');
    }
  },
  mounted() {
    this.count();
  },
}
</script>

<style scoped>
p {
  margin-bottom: 10px;
  margin-top: 0;
}

p::before {
  content: "> ";
  color: var(--tertiary-color);
}

.skip-container {
  position: absolute;
  bottom: 25px;
  right: 28px;
}

br {
  user-select: none;
}
</style>
